/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import CommonContext from "../../../../hooks/commonContext";
import AuthContext from "../../../../hooks/authContext";
import { Container, Button, useMediaQuery, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import {
  getCategories, fetchNotes,
  updateArchive,
  updateSupplyItemsStatus,
  updateSupplyItemDate,
  updateSuppliesStatus,
  closeSupplyOrder,
} from "../../../../services/apiservices/supplies";
import { Menu, MenuItem, IconButton } from '@material-ui/core';
import { getClientsListbasedonIds } from "../../../../services/apiservices/client";
import { getAllEmployee, getEmployeesListBasedOnId } from "../../../../services/apiservices/employee";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs from 'dayjs';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { convertFirestoreTimestampToDate, datetimest, formatDate, FormatedDates } from "../../../../services/helpers";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { saveNotification2, clothingSaveNotification } from "../../../../services/apiservices/notifications";
import Checkbox from '@mui/material/Checkbox';
import { NotesSection } from "./SuppliesNotes";
import { getSettings } from "../../../../services/apiservices/settings";
import { DOMAINURL_SUPPIESEMAIL } from "../../../../services/config";
import { Badge } from "../../../../components/ui/badge";
import { Package, Box, X } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../../components/ui/select";
import { cn } from "../../../../components/ui/utils";
import { useToast } from "../../../../hooks/useToast";
import { CommonConfirmationDialog } from "../../../../components/DialogComponent/SupplyDataDialog";
dayjs.extend(utc);
dayjs.extend(timezone);

const CheckBoxComponent = ({ rcellItem, rowIndex, handleCheckboxChange, isChecked }) => {
  return (
    <Checkbox
      checked={isChecked}
      onChange={() => handleCheckboxChange(rcellItem?.id)}
    />
  );
};

// const SuccessDialog = ({ open, onClose }) => {
//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogContent>
//         This order has been successfully Archived for Future Reference.
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} color="primary">
//           Close
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

const ManageSuppliesRequestDetails = (props) => {
  const commonContext = useContext(CommonContext);
  const { userProfile } = useContext(AuthContext);
  const { requestId } = useParams();
  const [requestData, setRequestData] = React.useState({});
  const [allSupplies, setAllSupplies] = React.useState([]);
  const [notes, setNotes] = useState([]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [openDatePickerId, setOpenDatePickerId] = useState(null);
  const [categories, setCategories] = useState({});
  const [empName, setEmployeeName] = useState();
  const [empData, setEmpData] = useState();
  const [clientData, setClientData] = useState();
  const [categoryMap, setCategoryMap] = useState({});
  const [data, setData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [pendingStatusUpdates, setPendingStatusUpdates] = useState({});
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showUnsavedPopup, setShowUnsavedPopup] = useState(false);
  const [newId, setNewId] = useState();
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [closeDialog, setCloseDialog] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [previousStatuses, setPreviousStatuses] = useState();
  const [settingsData, setSettingsData] = useState();
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const { toast } = useToast();
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const {showDetailsModal, setShowDetailsModal, selectedOrder, fetchSuppliesList} = props;


  const getRequestData = async (selectedOrder) => {
    if (!selectedOrder) {
      setRequestData({});
      setAllSupplies([]);
      commonContext?.setLoader(false);
      return;
    }
  
    try {
      commonContext?.setLoader(true);
  
      setData(selectedOrder);

      await Promise.all([
        fetchAndStoreCategories(selectedOrder?.supplyItems),
        fetchAndStoreCategoriesForEmail([selectedOrder])
      ]);
  
      const deliveryStatus = await getDeliveryStatus(selectedOrder?.supplyItems);
      const deliveryMap = {
        "Full Delivery": "Delivered",
        "cancelled": "Cancel Item",
        "Full Shipment": "Shipped",
        "In Process": "Ordered",
        "Back Ordered": "Back Ordered",
        "Partial Delivery": "Partial Delivery",
        "Partial Shipment": "Partial Shipment"
      };
      const newStatus = deliveryMap[deliveryStatus] || "Approved";
      const names = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`;
      if (newStatus !== selectedOrder?.status) {
        await updateSuppliesStatus(selectedOrder?.id, { status: newStatus }, names);
      }
  
      const [clientsRes, employeesRes] = await Promise.all([
        new Promise((resolve) =>
          getClientsListbasedonIds([selectedOrder?.clientId], resolve)
        ),
        new Promise((resolve) =>
          getEmployeesListBasedOnId([selectedOrder?.createdBy], resolve)
        )
      ]);
  
      const clintsData = clientsRes?.map((item) => ({
        value: item?.id,
        label: item?.clientName,
      }));
      setClientData(clintsData);
  
      const empData = employeesRes?.map((item) => ({
        value: item?.userId,
        label: `${item?.firstName} ${item?.lastName}`,
        email: item?.email,
        status: item?.status,
      }));
      setEmpData(empData);
      const name = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`;
      if (deliveryStatus === "cancelled") {
        await Promise.all([
          updateSuppliesStatus(selectedOrder?.id, { status: "Rejected" }, name),
          sendRejectNotification()
        ]);
        navigate(-1);
        return;
      }

      await getAllEmployee((result) => {
        const filtered = result?.data.filter(emp => emp.companyId === companyId);
        const employeeList = filtered?.map(emp => ({
          value: emp?.id || emp?.userId,
          label: `${emp?.firstName} ${emp?.lastName}`,
          status: emp.status,
        }));
        setEmployeeName(employeeList);
      });
  
      const clientName = clintsData?.find(c => c.value === selectedOrder?.clientId)?.label || 'Unknown Client';
      const employeeName = empData?.find(e => e.value === selectedOrder?.createdBy)?.label || 'Unknown Employee';
  
      const ids = selectedOrder?.supplyItems.map(item => item.id);
      setNewId(ids);

      const clothingItems = selectedOrder?.supplyItems.filter(
        item => item.title === 'Shirts' && item.hasOwnProperty('maxNumberAllowed')
      );
      const currentStatus = clothingItems?.[0]?.status || "";
  
      if (clothingItems.length > 0 && previousStatuses !== currentStatus && currentStatus === "Delivered") {
        await clothingCateNotification(empData, selectedOrder?.supplyItems, selectedOrder?.id, selectedOrder?.orderNumber);
      } else {
        setPreviousStatuses(currentStatus);
      }

      const finalData = {
        ...selectedOrder,
        orderNumber: String(selectedOrder?.orderNumber).padStart(6, '0'),
        clientName,
        employeeName,
        deliveryStatus
      };
  
      setRequestData(finalData);
      setAllSupplies(finalData?.supplyItems);
  
    } catch (error) {
      console.error("Error in getRequestData:", error);
    } finally {
      commonContext?.setLoader(false);
    }
  };
  
  useEffect(() => {
    setSelectedIds([]);
    setSelectedStatus('');
    setPendingStatusUpdates({});
  
    getRequestData(selectedOrder);
  
    getSettings('supplie_settings', companyId, (res) => {
      if (res?.data.length > 0) {
        const filtered = res.data.filter(item => !item.deleted);
        setSettingsData(filtered?.[0]);
      } else {
        setSettingsData();
      }
    });
  }, [selectedOrder]);
  

  useEffect(() => {
    const loadNotes = async () => {
      if (!selectedOrder?.id) {
        setNotes([{ message: 'No ID provided' }]);
        return;
      }
  
      fetchNotes(
        selectedOrder?.id,
        (fetchedNotes) => setNotes(fetchedNotes),
        (error) => {
          console.error('Error fetching notes:', error);
          setNotes([{ message: 'Error fetching notes' }]);
        }
      );
    };
  
    loadNotes();
  }, [selectedOrder]);
  

  const handleNote = (newNote) => {
    setNotes([...notes, newNote]);
  };

  const fetchAndStoreCategories = async (items) => {
    for (const item of items) {
      if (item?.parentCategoryId) {
        await getCategories(companyId, (categoriesData) => {

          if (Array.isArray(categoriesData)) {
            const category = categoriesData.find(cate => cate?.id === item.parentCategoryId);
            const title = category?.title;

            if (title) {
              setCategories(prevCategories => ({
                ...prevCategories,
                [item.parentCategoryId]: title,
              }));
            }
          } else {
            console.error('Expected categoriesData to be an array, but got:', categoriesData);
          }
        });
      }
    }
  };

  const fetchAndStoreCategoriesForEmail = async (res) => {
    const newCategoryMap = {};

    let categoriesData = [];
    try {
      await getCategories(companyId, (res)=>{
        categoriesData = res;
      });
    } catch (error) {
      console.error("Error fetching categories:", error);
      categoriesData = [];
    }

    for (const item of res) {
      const { id: mainId, supplyItems } = item;
      if (supplyItems) {
        const categoriesForItem = [];
        for (const supplyItem of supplyItems) {
          const { parentCategoryId } = supplyItem;
          if (parentCategoryId && Array.isArray(categoriesData)) {
            try {
              const category = categoriesData?.find((cate) => cate?.id === parentCategoryId);
              const title = category?.title;
              if (title) {
                categoriesForItem.push({
                  parentCategoryId,
                  title
                });
              }
            } catch (error) {
              console.error(`Error fetching category for parentCategoryId ${parentCategoryId}:`, error);
            }
          }
        }
        newCategoryMap[mainId] = categoriesForItem;
      }
    }

    setCategoryMap(newCategoryMap);
  };


  const clothingCateNotification = async (empData, data, OrdersId, orderNumber) => {
    if (!empData || !data) {
      console.error("Missing empData or data");
      return;
    }
    let orderId = String(orderNumber).padStart(6, '0');
    const supply = true;
    const clientName = clientData ? clientData[0].label : null;
    const employee = empData?.find((emp) => emp.value === data.createdBy && emp.status !== false);
    if (!employee) return;
    const name = employee ? employee.label : '';
    const email = employee ? employee.email : '';
    const formattedMessage = `Your clothing (shirt) request has been completed and delivered.`;
    const EmailMessage =
      `<p>Hello</p>
     <p>Your request for your company shirts has been completed and your item(s) have been delivered. 
       If there are any issues with these items, please contact your support team.</p>
     <p>Thank You</p>
     <p>Proteams Support Team</p>`

    const notifications = [
      {
        Type: "PushNotification",
        Message: formattedMessage,
        read: false,
        companyId: companyId,
        Employee: [
          {
            id: data?.createdBy,
            name: name
          }
        ],
        extData: { type: "Supplies", id: OrdersId }
      },
      {
        Type: "Email",
        Message: EmailMessage,
        read: false,
        companyId: companyId,
        Employee: [
          {
            id: data?.createdBy,
            name: name,
            email: email
          }
        ]
      }
    ];
    await clothingSaveNotification(notifications, supply, orderId, clientName);
  }

  const handleCheckboxChange = (id) => {
    setSelectedIds((prevSelectedIds) => {
      let updatedSelectedIds;

      if (prevSelectedIds.includes(id)) {
        updatedSelectedIds = prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        updatedSelectedIds = [...prevSelectedIds, id];
      }

      const allIds = newId;
      const allSelected = allIds.length > 0 && allIds.every(id => updatedSelectedIds.includes(id));

      setSelectAllChecked(allSelected);
      return updatedSelectedIds;
    });
  };

  const handleSelectAllChange = () => {
    const allIds = newId;

    if (selectAllChecked) {
      setSelectedIds([]);
    } else {
      setSelectedIds(allIds);
    }

    setSelectAllChecked(!selectAllChecked);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsMenuOpen(true);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setIsMenuOpen(false);
  };

  const handleCloseDetails = () => {
    if (Object.keys(pendingStatusUpdates)?.length > 0) {
      setShowUnsavedPopup(true);
      return;
    }

    setShowDetailsModal(false);
    localStorage.removeItem("supplyId");
  };

  const handleStatusSelect = (status, id) => {
    setPendingStatusUpdates(prev => ({
      ...prev,
      [id]: status,
    }));
    handleMenuClose();
  };

  const handleCloseCancelDialog = () => {
    setShowUnsavedPopup(false);
  }

  const handleConfirmCancelDialog = () => {
    setShowUnsavedPopup(false);
    setPendingStatusUpdates({});
    setShowDetailsModal(false);
    localStorage.removeItem("supplyId");
  }

  const handleUpdateAllStatuses = async () => {
    try {
      setShowUnsavedPopup(false);
      const orderId = selectedOrder?.id;
      if (!orderId) return;

      const originalItems = selectedOrder?.supplyItems || [];

      const updatedSupplyItems = originalItems?.map(item => {
        const pendingStatus = pendingStatusUpdates[item.id];
        return pendingStatus
          ? { ...item, status: pendingStatus }
          : item;
      });

      await updateSupplyItemsStatus(
        orderId,
        null,
        null,
        () => {},      
        (error) => console.error("Failed:", error),
        updatedSupplyItems
      );

      toast?.({
        title: "Success",
        description: "All item statuses updated successfully"
      });

      setPendingStatusUpdates({});
      setSelectedIds([]);
      setSelectedStatus("");
      setSelectAllChecked(false);
      
    } catch (error) {
      console.error("Update all error:", error);
    }
  };

  const allStatuses = ['Ordered', 'Shipped', 'Delivered', 'Back Ordered', 'Cancel Item'];

  const sendRejectNotification = async () => {
    let name;
    let email;
    let orderId = String(data?.orderNumber).padStart(6, '0');
    const supply = true;
    const clientName = clientData ? clientData[0].label : null;
    const companyName = `${auth?.userProfile?.companyData?.data?.companyName}`;

    const employee = empData?.find((emp) => emp.value === data.createdBy && emp.status !== false);
    if (!employee) return;
      name = employee?.label;
      email = employee?.email;

    let updatedTitles = [];
    const category = categoryMap[data.id];
    if (category) {
      updatedTitles = data.supplyItems.map((supplyItem, index) => {
        const categoryItem = category.find(cat => cat.parentCategoryId === supplyItem.parentCategoryId);
        const title = categoryItem ? `${categoryItem.title} - ${supplyItem.title}` : `${supplyItem.title}`;
        return `${index + 1}. ${title} (${supplyItem.qty})`;
      });
    }

    const updatedTitlesStr = updatedTitles.join('\n');
    const link = `https://${DOMAINURL_SUPPIESEMAIL}/Supplies/${data.id}`
    const notifications = [
      {
        Type: "PushNotification",
        Message: `Your supply request OrderID ${orderId} has been cancelled. Please check your email.`,
        read: false,
        companyId: companyId,
        Employee: [
          {
            id: data?.createdBy,
            name: name
          }
        ]
      },
      {
        Type: "Email",
        Message: `Your supply request OrderId ${orderId} has been canceled by the support team.<br>
          Please contact us to resubmit a new request or discuss this order with your support team.<br>
          Details:\n 
          ${updatedTitlesStr}<br><br>
          <p>To respond to this message, please click <a href="${link}" target="_blank">here</a> to open the issue the <span style="white-space: nowrap;">ProTeams</span> app.</p><br>
          ProTeams Support Team`,
        read: false,
        companyId: companyId,
        Employee: [
          {
            id: data?.createdBy,
            name: name,
            email: email
          }
        ]
      }
    ];
    await saveNotification2(notifications, supply, orderId, clientName, companyName);
  };

  const getDeliveryStatus = (supplyItems) => {
    if (!supplyItems || !Array.isArray(supplyItems)) {
      return 'Invalid Supplies';
    }

    const statuses = supplyItems.map(item => item.status);

    const hasDelivered = statuses.includes('Delivered');
    const hasShipped = statuses.includes('Shipped');
    const hasOrdered = statuses.includes('Ordered');
    const hasBackOrdered = statuses.includes('Back Ordered');
    const hasCancelItem = statuses.includes('Cancel Item');

    if (statuses.every(status => status === 'Delivered') || (hasDelivered && hasCancelItem && !hasOrdered && !hasBackOrdered && !hasShipped)) {
      return 'Full Delivery';
    }
    if (statuses.every(status => status === 'Cancel Item')) {
      return 'cancelled';
    }
    if (hasDelivered && (hasShipped || hasOrdered || hasBackOrdered || hasCancelItem)) {
      return 'Partial Delivery';
    }
    if (statuses.every(status => status === 'Shipped') || (hasShipped && hasCancelItem && !hasDelivered && !hasOrdered && !hasBackOrdered)) {
      return 'Full Shipment';
    }
    if (hasShipped && (hasOrdered || hasBackOrdered) && !hasDelivered) {
      return 'Partial Shipment';
    }
    if (hasOrdered && hasCancelItem) {
      return 'In Process';
    }
    if (statuses.every(status => status === 'Ordered')) {
      return 'In Process';
    }
    if (statuses.every(status => status === 'Back Ordered')) {
      return 'Back Ordered';
    }
    if (hasOrdered && hasBackOrdered) {
      return 'In Process';
    }
    return 'In Process';
  };

  const handleDateIconClick = (id) => {
    if (openDatePickerId === id) {
      setShowDatePicker(false);
      setOpenDatePickerId(null);
    } else {
      setOpenDatePickerId(id);
      setShowDatePicker(true);
    }
  };

  const handleDateChangeConfirmed = (id, date) => {
    const utcDate = dayjs(date).toISOString();
    updateDeliveryDate(requestData.id, id, utcDate);
    setShowDatePicker(false);
  };

  const handleDateChangeCancelled = () => {
    setShowDatePicker(false);
  };

  const handleArchive = async () => {
    const formData = {
      archive: true,
      archiveAt: datetimest()
    }
    setShowDetailsModal(false);
    localStorage.removeItem('supplyId')
    await updateArchive(selectedOrder?.id, formData);
    // await fetchSuppliesList();
    toast?.({title: "Success", description: "Order Archive Successfully"});
  }

  const handleCloseDialog = async () => {
    setDialogOpen(false);
    navigate(-1);
  };

  const isUndelivered = requestData.supplyItems && requestData.supplyItems.every(item => item.status === 'Delivered' || item.status === 'Cancel Item');

  const isSelected = selectedIds.length > 0;

  const updateDeliveryDate = async (requestId, itemId, date) => {
    try {
      await updateSupplyItemDate(
        requestId,
        itemId,
        date,
        (data) => {
          if (data) {
            getRequestData(requestId);
          }
        },
        (error) => {
          console.error("Failed to update status:", error);
        }
      );
    } catch (error) {
      console.error("Error in handleUpdateStatus:", error);
    }
  };


  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case "categories":
        if (rowindex !== 0 && categories[rcellItem?.parentCategoryId] !== categories[requestData.supplyItems[rowindex - 1]?.parentCategoryId]) {
          return <span>{categories[rcellItem?.parentCategoryId]}</span>
        }
        else if (rowindex === 0) {
          return <span>{categories[rcellItem?.parentCategoryId]}</span>
        } else {
          return "";
        }
      case "supplies":
        return `${rcellItem?.title} (${rcellItem?.qty})`;
      case "deliveryDate":
        const data = convertFirestoreTimestampToDate(rcellItem?.deliveryDate);
        const dates = dayjs(data).format('YYYY-MM-DD').isValid;
        return (
          <>
            <span>
              {rcellItem?.deliveryDate ? formatDate(rcellItem?.deliveryDate) : "---"}
            </span>

            <IconButton className="p-5" >
              <DateRangeIcon className="color-primary" style={{ padding: 0 }} fontSize="small" onClick={() => handleDateIconClick(rcellItem?.id)} />
            </IconButton>
            {showDatePicker && openDatePickerId === rcellItem?.id && (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DesktopDatePicker']}>
                  <DesktopDatePicker
                    value={data ? dayjs(data) : dayjs(dates).local()}
                    onAccept={(date) => handleDateChangeConfirmed(rcellItem?.id, date)}
                    onClose={() => {
                      handleDateChangeCancelled();
                      setOpenDatePickerId(null);
                    }}
                    format="YYYY-MM-DD"
                  />
                </DemoContainer>
              </LocalizationProvider>
            )}
          </>
        );
      case "status":
        return rcellItem.status;
      case "checkbox":
        return (
          <CheckBoxComponent
            rcellItem={rcellItem}
            rowIndex={rowindex}
            handleCheckboxChange={handleCheckboxChange}
            isChecked={selectedIds.includes(rcellItem?.id)}
          />
        );
      default:
        return rcellItem[hcellItem?.id];
    }
  };
  const datePickerProps = { openDatePickerId, showDatePicker, setShowDatePicker, setOpenDatePickerId, updateDeliveryDate };
  const checkProps = {
    isSelected, handleMenuClick, anchorEl, isMenuOpen, handleMenuClose, allStatuses, selectedStatus, handleStatusSelect,
    isUndelivered, handleArchive, selectAllChecked, handleSelectAllChange
  };

  const getPriorityBadgeVariant = (priority) => {
    switch (priority) {
      case "1":
        return "danger";
      case "2":
        return "warning";
      case "3":
        return "info";
      default:
        return "secondary";
    }
  };

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case "1":
        return "High";
      case "2":
        return "Medium";
      case "3":
        return "Low";
      default:
        return "Unknown";
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Ordered":
        return "bg-blue-100 text-blue-800";
      case "Delivered":
        return "bg-green-100 text-green-800";
      case "Shipped":
        return "bg-purple-100 text-purple-800";
      case "In Process":
        return "bg-slate-100 text-slate-800";
      case "Back Ordered":
        return "bg-slate-100 text-slate-800";
      case "Cancel Item":
        return "bg-gray-100 text-gray-800";
      case "Archived":
        return "bg-gray-100 text-gray-800";
      default:
        return "bg-slate-100 text-slate-800";
    }
  };

  const getDeliveryStatusColor = (status) => {
    switch (status) {
      case "Full Delivery":
        return "bg-green-100 text-green-800";
      case "Partial Delivery":
        return "bg-blue-100 text-blue-800";
      case "Full Shipment":
        return "bg-purple-100 text-purple-800";
      case "Partial Shipment":
        return "bg-indigo-100 text-indigo-800";
      case "In Process":
        return "bg-slate-100 text-slate-800";
      case "Cancelled":
        return "bg-red-100 text-red-800";
      case "Back Ordered":
        return "bg-red-100 text-red-800";
      default:
        return "bg-slate-100 text-slate-800";
    }
  };

  const getTotalItems = () => {
    return selectedOrder?.supplyItems?.reduce((total, supply) => total + supply?.qty, 0);
  };

  const handleCloseOrder = async () => {
    if (!selectedOrder?.id) return toast?.({ title: "Error", description: "No order selected" });

    setCloseDialog(false);
    setShowDetailsModal(false);
    localStorage.removeItem('supplyId');

    await closeSupplyOrder(
      selectedOrder.id,
      (updatedOrder) => {
        toast?.({ title: "Success", description: "Order closed successfully" });
      },
      (error) => {
        toast?.({ title: "Error", description: error?.message || error });
      }
    );
  };


  const deliverStatus = getDeliveryStatus(selectedOrder?.supplyItems);

  return (
    <>
      <Dialog open={showDetailsModal} onOpenChange={setShowDetailsModal}>
        <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto dark:bg-[#1A1F2C]">
          <div className="mb-20">
            <div className="d-flex flex-space-between flex-center">
              <div className="d-flex flex-center gap-2 text-xl p-0">
                <Package className="h-5 w-5 text-[#020817] dark:text-white" />
                <span
                  style={{ fontSize: "20px" }}
                  className="text-[#020817] dark:text-white"
                >
                  Order Details #{selectedOrder?.orderId}  {selectedOrder?.employeeName}
                </span>
              </div>
              <div style={{cursor:"pointer"}} onClick={handleCloseDetails}>
                <X className="h-5 w-5 text-[#020817] dark:text-white" />
              </div>
            </div>
            <div className="mt-8" style={{ color: "#64748B" }}>
              View and update order information
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-32">
            <div>
              <h3 className="font-semibold mb-16 text-[#020817] dark:text-white" style={{ fontSize:"16px"}}>Order Information</h3>
              <div className="space-y-2">
                <div className="flex justify-between border-b pb-8">
                  <span className="text-muted-foreground" style={{color:"#64748B", fontSize:"16px"}}>Order ID:</span>
                  <span className="font-medium text-[#020817] dark:text-white">{selectedOrder?.orderId}</span>
                </div>
                <div className="flex justify-between border-b pb-8">
                  <span className="text-muted-foreground" style={{color:"#64748B", fontSize:"16px"}}>Date:</span>
                  <span className="text-[#020817] dark:text-white">{FormatedDates(selectedOrder?.dateOfRequest)}</span>
                </div>
                <div className="flex justify-between border-b pb-8">
                  <span className="text-muted-foreground" style={{color:"#64748B", fontSize:"16px"}}>Client:</span>
                  <span className="text-[#020817] dark:text-white">{selectedOrder?.clientName}</span>
                </div>
                <div className="flex justify-between border-b pb-8">
                  <span className="text-muted-foreground" style={{color:"#64748B", fontSize:"16px"}}>Employee:</span>
                  <span className="text-[#020817] dark:text-white">{selectedOrder?.employeeName}</span>
                </div>
                <div className="flex justify-between border-b pb-8">
                  <span className="text-muted-foreground" style={{color:"#64748B", fontSize:"16px"}}>Items:</span>
                  <div className="flex items-center gap-1">
                    <Box className="h-4 w-4 text-[#020817] dark:text-white" />
                    <span className="text-[#020817] dark:text-white">{getTotalItems()}</span>
                  </div>
                </div>
                <div className="flex justify-between border-b pb-8">
                  <span className="text-muted-foreground"style={{color:"#64748B", fontSize:"16px"}}>Priority:</span>
                  <Badge
                    variant={getPriorityBadgeVariant(selectedOrder?.priority)}
                  >
                    {getPriorityLabel(selectedOrder?.priority)}
                  </Badge>
                </div>
                <div className="flex justify-between border-b pb-8">
                  <span className="text-muted-foreground"style={{color:"#64748B", fontSize:"16px"}}>Order Status:</span>
                  <Badge className={getStatusColor(selectedOrder?.orderStatus)}>
                    {selectedOrder?.orderStatus}
                  </Badge>
                </div>
                <div className="flex justify-between border-b pb-8">
                  <span className="text-muted-foreground" style={{color:"#64748B", fontSize:"16px"}}>
                    Delivery Status:
                  </span>
                  <Badge className={getDeliveryStatusColor(deliverStatus)}>
                    {deliverStatus}
                  </Badge>
                </div>
                {/* <div className="flex justify-between pb-1">
                <span className="text-muted-foreground">Est. Delivery:</span>
                <span>{format(selectedOrder?.estimatedDelivery, "MMM d, yyyy")}</span>
              </div> */}
              </div>
            </div>

            <div>
              <h3 className="font-semibold mb-16 text-[#020817] dark:text-white dark:bg-[#1A1F2C]" style={{fontSize:"16px"}}>Supplies</h3>
              <div className="bg-slate-50  dark:bg-[#1A1F2C] pv-20 ph-16 rounded-md space-y-3">
                {selectedOrder?.supplyItems?.map((supply) => (
                  <div key={supply?.id} className="border-b last:border-0 pb-12">
                    <div className="flex justify-between items-center">
                      <span className="font-medium dark:text-white">{supply?.title}</span>
                      <span className="dark:text-white">x{supply?.qty}</span>
                    </div>
                    <div className="flex justify-between items-center mt-16">
                      <span className="text-sm text-muted-foreground mr-5">
                        Delivery Status:
                      </span>
                      <div className="flex items-center">
                        <Select
                          defaultValue={supply?.status}
                          onValueChange={(value) =>
                            handleStatusSelect(
                              value,
                              supply?.id
                            )
                          }
                        >
                          <SelectTrigger className="w-[180px] h-8 dark:text-white dark:placeholder-white">
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent style={{zIndex:"9999"}} className="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]">
                            <SelectItem value="Ordered" className="hover:bg-gray-100 dark:hover:bg-[#3c4351]">Ordered</SelectItem>
                            <SelectItem value="Shipped" className="hover:bg-gray-100 dark:hover:bg-[#3c4351]">Shipped</SelectItem>
                            <SelectItem value="Delivered" className="hover:bg-gray-100 dark:hover:bg-[#3c4351]">Delivered</SelectItem>
                            <SelectItem value="Back Ordered" className="hover:bg-gray-100 dark:hover:bg-[#3c4351]">
                              Back Ordered
                            </SelectItem>
                            <SelectItem value="Cancel Item" className="hover:bg-gray-100 dark:hover:bg-[#3c4351]">
                              Cancel Item
                            </SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>
                    <div className="flex justify-end mt-8">
                      <Badge
                        className={cn(
                          "capitalize",
                          getStatusColor(supply?.status)
                        )}
                      >
                        {supply?.status}
                      </Badge>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="d-flex flex-justify-end mb-10">
            <Button variant="contained" color="primary" style={{color:"white"}} className="dark:text-white" onClick={() => handleUpdateAllStatuses()}>
              Update Supplies
            </Button>
          </div>

          <NotesSection
              notes={notes}
              onAddNote={handleNote}
              employee={empName}
              createdBy={userProfile?.id}
              orderId={selectedOrder?.id}
              setNotes={setNotes}
              data={selectedOrder}
              empData={empData}
              clientData={clientData}
              commonContext={commonContext}
              categoryMap={categoryMap}
            />

          <div className="flex flex-justify-end mt-12">
            {/* <Button
              variant="contained"
              style={{color:"white", backgroundColor:"red"}}
              onClick={() => handleArchive()}
            >
              Archive Order
            </Button> */}
            <Button
              variant="outlined"
              className="dark:text-white"
              onClick={handleCloseDetails}
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <CommonConfirmationDialog 
        open={showUnsavedPopup}
        message={"You have made changes to this order. Please click Update to save those changes. Are you sure you want to close without saving?"}
        title={"Unsaved Changes"}
        onConfirm={handleConfirmCancelDialog}
        onClose={handleCloseCancelDialog}
      />

      {/* <Dialog open={closeDialog} onOpenChange={setCloseDialog}>
        <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto dark:bg-[#1A1F2C] ph-40 pt-40 pb-20">
          <div className="mb-30 font-medium text-[18px] dark:text-white">
            Are you sure you want to close this order?
          </div>

          <div className="d-flex flex-justify-end flex-center">
            <Button variant="outlined" onClick={() => setCloseDialog(false)} className="dark:text-white mr-20">
              No
            </Button>
            <Button variant="contained" onClick={handleCloseOrder} className="dark:text-white" style={{ color: "white", backgroundColor: "green" }}>
              Yes
            </Button>
          </div>
        </DialogContent>
      </Dialog> */}
    </>
  );
};

export default ManageSuppliesRequestDetails;
